import { useState, useEffect } from "react";
import {
  ProSidebar,
  Menu,
  MenuItem,
  SubMenu,
  SidebarHeader,
  SidebarFooter,
  SidebarContent,
} from "react-pro-sidebar";
import { Box, IconButton, InputAdornment, TextField, Typography, useTheme } from "@mui/material";
import { NavLink, useLocation } from "react-router-dom";
import "react-pro-sidebar/dist/css/styles.css";
import Tooltip from "@mui/material/Tooltip";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import ContactsOutlinedIcon from "@mui/icons-material/ContactsOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import SellOutlinedIcon from "@mui/icons-material/SellOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import LibraryBooksOutlinedIcon from "@mui/icons-material/LibraryBooksOutlined";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import SnippetFolderOutlinedIcon from "@mui/icons-material/SnippetFolderOutlined";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import DvrOutlinedIcon from "@mui/icons-material/DvrOutlined";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import FactoryOutlinedIcon from "@mui/icons-material/FactoryOutlined";
import RequestQuoteOutlinedIcon from "@mui/icons-material/RequestQuoteOutlined";
import BalanceOutlinedIcon from "@mui/icons-material/BalanceOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import ConnString from "../../ConnString.js";

const Connstring2 = ConnString.connstring;

const SidebarItem = ({ title, to, icon, selected, collapsed }) => {
  const theme = useTheme();
  const motif = theme.palette.motif;
  const itemText = motif.text;

  return (
    <MenuItem
      active={selected === to}
      icon={icon}
      style={{
        borderRadius: "14px",
        margin: "6px 8px",
        color: itemText,
      }}
    >
      <NavLink
        to={to}
        end
        style={({ isActive }) => ({
          color: itemText,
          textDecoration: "none",
          display: "flex",
          alignItems: "center",
          width: "100%",
          padding: "10px 14px",
          borderRadius: "12px",
          background: isActive ? motif.panelStrong : "transparent",
        })}
      >
        <Typography sx={{ fontSize: collapsed ? 0 : "0.95rem", fontWeight: 600 }}>
          {title}
        </Typography>
      </NavLink>
    </MenuItem>
  );
};

const mainLinks = [
  { id: "dashboard", title: "Dashboard", to: "dashboard", icon: <HomeOutlinedIcon /> },
  { id: "monitoring", title: "Monitoring", to: "monitoring", icon: <TrendingUpOutlinedIcon /> },
  { id: "monitoring", title: "Tasks", to: "TLMonitoringTasks", icon: <TrendingUpOutlinedIcon /> },
  { id: "monitoring", title: "Client Profile", to: "TlClientProfile", icon: <TrendingUpOutlinedIcon /> },

  { id: "retainer", title: "Retainers", to: "retainer", icon: <RequestQuoteOutlinedIcon /> },
  { id: "calendar", title: "Calendar", to: "calendar", icon: <CalendarTodayOutlinedIcon /> },
];

const salesLinks = [
  { id: "ACTCRP", title: "Cash Receipts", to: "TLCashReceipts", icon: <PaidOutlinedIcon /> },
  { id: "ACTSOA", title: "Sales On Account", to: "TLSalesOnAccount", icon: <ReceiptOutlinedIcon /> },
  { id: "ACTBST", title: "Billing Statement", to: "TLBillingStatement", icon: <ReceiptLongOutlinedIcon /> },
  { id: "ACTSRC", title: "Service Contract", to: "TLServiceContracts", icon: <DescriptionOutlinedIcon /> },
];

const purchaseLinks = [
  { id: "ACTPVC", title: "Payment Voucher", to: "TLPaymentVoucher", icon: <PaymentsOutlinedIcon /> },
  { id: "ACTPOA", title: "Purchase On Account", to: "TLPurchaseOnAccount", icon: <ShoppingCartOutlinedIcon /> },
];

const genAcctLinks = [
  { id: "ACTJOV", title: "Journal Voucher", to: "TLJournalVoucher", icon: <MenuBookOutlinedIcon /> },
  { id: "ACTJVT", title: "JV Template", to: "TLJVTemplate", icon: <InsertDriveFileOutlinedIcon /> },
  { id: "ACTRJV", title: "Recurring JV", to: "TLRecurringJV", icon: <FactoryOutlinedIcon /> },
];
const ARReportLinks = [
  { id: "ARAG", title: "A/R Aging", to: "Report_ARAging", icon: <AssessmentOutlinedIcon /> },
];
const ISACAFSReportLinks = [
  { id: "ISACARPTIS", title: "Income Statement", to: "Report_ISACA_IS", icon: <AssessmentOutlinedIcon /> },
   { id: "ISACARPTBS", title: "Balance Sheet", to: "Report_ISACA_BS", icon: <AssessmentOutlinedIcon /> },
   { id: "ISACARPTTB", title: "Trial Balance", to: "Report_ISACA_TB", icon: <AssessmentOutlinedIcon /> },
];
const LiquidationReportLinks = [
  { id: "LIQREP", title: "Liquidation Report", to: "Report_LiquidationReport", icon: <AssessmentOutlinedIcon /> },
];

const AuditModuleLinks = [
  { id: "Audit", title: "Audit", to: "team", icon: <MenuBookOutlinedIcon /> },
  { id: "AUDMFC", title: "Company Profiles", to: "AUD_CompanyProfile", icon: <InsertDriveFileOutlinedIcon /> },
  { id: "AUDRPT", title: "Audit Report", to: "contacts", icon: <FactoryOutlinedIcon /> },
  { id: "AUDAFS", title: "Audited Financial Statements", to: "contacts", icon: <FactoryOutlinedIcon /> },
];

const InventoryModuleLinks = [
  { id: "INVTRYDB", title: "Inventory Dashboard", to: "InventoryDashboard", icon: <MenuBookOutlinedIcon /> },
];
const InventoryInLinks = [
  { id: "PROCPO", title: "Purchase Order", to: "InventoryPurchaseOrder", icon: <ShoppingCartOutlinedIcon /> },
  { id: "INVREC", title: "Receiving", to: "InventoryReceiving", icon: <LocalShippingOutlinedIcon /> },
  { id: "INVSTI", title: "Stock IN", to: "InventoryTransferIn", icon: <StorefrontOutlinedIcon /> },
];
const InventoryOutLinks = [
  { id: "SLSSOR", title: "Sales Order", to: "InventorySalesOrder", icon: <SellOutlinedIcon /> },
  { id: "INVDEL", title: "Delivery", to: "InventoryDelivery", icon: <LocalShippingOutlinedIcon /> },
  { id: "INVSTO", title: "Stock OUT", to: "InventoryTransferOut", icon: <StorefrontOutlinedIcon /> },
];
const InventoryReportLinks = [
  { id: "INVRP1", title: "Remaining Inventory Report", to: "InventoryReport?report=remaining", icon: <AssessmentOutlinedIcon /> },
  { id: "INVRP2", title: "Stock Movement Report", to: "InventoryReport?report=movement", icon: <AssessmentOutlinedIcon /> },
  { id: "INVRP3", title: "Aging of Inventory Report", to: "InventoryReport?report=aging", icon: <AssessmentOutlinedIcon /> },
  { id: "INVRP4", title: "Critical Inventory Report", to: "InventoryReport?report=critical", icon: <AssessmentOutlinedIcon /> },
];

const SidebarSubMenu = ({ title, to, icon, collapsed, children }) => {
  const theme = useTheme();
  const location = useLocation();
  const motif = theme.palette.motif;
  const submenuPalette = {
    defaultText: motif.text, activeText: motif.text, activeBg: motif.panelStrong,
    hoverBg: motif.panel, panelBg: motif.navPanel, border: motif.main,
    panelBorder: motif.border, arrowColor: motif.main,
    textSize: "0.80rem", itemTextSize: "0.80rem", fontWeight: 600,
  };

  const path = location.pathname || "";
  const lastSeg = path.split("/").filter(Boolean).pop() || "";
  const isActive = to && (path.includes(`/${to}`) || lastSeg === to);

  const titleContent = to ? (
    <NavLink
      to={to}
      end
      onClick={(event) => event.stopPropagation()}
      style={({ isActive: navIsActive }) => ({
        color: navIsActive || isActive ? submenuPalette.activeText : submenuPalette.defaultText,
        textDecoration: "none",
        display: "flex",
        alignItems: "center",
        width: "100%",
        padding: "8px 12px",
        borderRadius: "12px",
        background: navIsActive || isActive ? submenuPalette.activeBg : "transparent",
        border: navIsActive || isActive ? `1px solid ${submenuPalette.border}` : "1px solid transparent",
        transition: "background 160ms ease, color 160ms ease, border-color 160ms ease",
      })}
    >
      <Typography sx={{ fontSize: collapsed ? 0 : submenuPalette.textSize, fontWeight: submenuPalette.fontWeight }}>
        {title}
      </Typography>
    </NavLink>
  ) : (
    title
  );

  return (
    <SubMenu title={titleContent} icon={icon}>
      {children}
    </SubMenu>
  );
};

const Sidebar = () => {
  const theme = useTheme();
  const location = useLocation();
  const selected = location.pathname.split("/").filter(Boolean).pop() || "dashboard";
  const [collapsed, setCollapsed] = useState(false);
  const [company, setCompany] = useState(
    sessionStorage.getItem("compName") || sessionStorage.getItem("selectedCompany") || "Business Journal"
  );
  const [userName, setUserName] = useState(
    sessionStorage.getItem("userFullName") || sessionStorage.getItem("userEmail") || "Admin"
  );
  const [compLogo, setCompLogo] = useState(sessionStorage.getItem("compLogo"));
  const [compID, setCompID] = useState(sessionStorage.getItem("compID"));
  const [userID, setUserID] = useState(sessionStorage.getItem("userID"));
  const [access, setAccess] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const dark = theme.palette.mode === "dark";
  const motif = theme.palette.motif;
  const submenuPalette = {
    defaultText: motif.text, activeText: motif.text, activeBg: motif.panelStrong,
    hoverBg: motif.panel, panelBg: motif.navPanel, border: motif.main,
    panelBorder: motif.border, arrowColor: motif.main,
    textSize: "0.80rem", itemTextSize: "0.80rem", fontWeight: 600,
  };
  const sidebarPalette = {
    background: motif.nav, panel: motif.navPanel, border: motif.border,
    text: motif.text, muted: motif.muted, icon: motif.main,
    active: motif.panelStrong, hover: motif.panel,
    input: dark ? motif.panelStrong : motif.paper, submenu: submenuPalette,
  };

  useEffect(() => {
    const fetchAccess = async () => {
      if (!compID || !userID) return;
      try {
        const res = await fetch(`${Connstring2}/api/user-access`, {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ companyID: compID, currentuserID: userID }),
        });
        const data = await res.json();
        if (data.success) {
          sessionStorage.setItem("userAccess", JSON.stringify(data.access));
          setAccess(data.access);
        }
      } catch (error) {
        console.error("Failed to fetch user access:", error);
      }
    };

    fetchAccess();
  }, [compID, userID]);

  const canAccess = (id) => access.includes(id);
  const showSales = salesLinks.some((item) => canAccess(item.id));
  const showPurchases = purchaseLinks.some((item) => canAccess(item.id));
  const showGenAcct = genAcctLinks.some((item) => canAccess(item.id));
  const showTransactions = showSales || showPurchases || showGenAcct;
  
  
  const showARAging = ARReportLinks.some((item) => canAccess(item.id));
  
  const showLiquidationReport = LiquidationReportLinks.some((item) => canAccess(item.id));
 
  const showFSReportItems_Isaca = ISACAFSReportLinks.some((item) => canAccess(item.id));
  

  const showReports = showARAging || showLiquidationReport||showFSReportItems_Isaca;
  const showARReports  = showARAging||showLiquidationReport;
  const showFSReports_Isaca  = showFSReportItems_Isaca;

  

  const showAUCompProfile = AuditModuleLinks.some((item) => canAccess(item.id));
  const showAuditModule = showAUCompProfile; // You can add more conditions if there are more links in the AuditModuleLinks array
  
  const showInventoryIn = InventoryInLinks.some((item) => canAccess(item.id));
  const showInventoryOut = InventoryOutLinks.some((item) => canAccess(item.id));
  const showInventoryReports = InventoryReportLinks.some((item) => canAccess(item.id));
  const showInventory = InventoryModuleLinks.some((item) => canAccess(item.id)) || showInventoryIn || showInventoryOut || showInventoryReports;
  const normalizedSearch = searchQuery.trim().toLowerCase();
  const searchableLinks = [
    ...mainLinks.map((item) => ({ ...item, group: "Main" })),
    ...salesLinks.map((item) => ({ ...item, group: "Sales" })),
    ...purchaseLinks.map((item) => ({ ...item, group: "Purchases" })),
    ...genAcctLinks.map((item) => ({ ...item, group: "Gen. Acctg" })),
    ...ARReportLinks.map((item) => ({ ...item, group: "AR Reports" })),
    ...LiquidationReportLinks.map((item) => ({ ...item, group: "AR Reports" })),
    ...ISACAFSReportLinks.map((item) => ({ ...item, group: "Financial Reports" })),
    ...AuditModuleLinks.map((item) => ({ ...item, group: "Audit" })),
    ...InventoryModuleLinks.map((item) => ({ ...item, group: "Inventory" })),
    ...InventoryInLinks.map((item) => ({ ...item, group: "Inventory IN" })),
    ...InventoryOutLinks.map((item) => ({ ...item, group: "Inventory Out" })),
    ...InventoryReportLinks.map((item) => ({ ...item, group: "Inventory Reports" })),
  ];
  const searchResults = normalizedSearch
    ? searchableLinks.filter((item, index, items) =>
        canAccess(item.id)
        && `${item.title} ${item.group} ${item.id}`.toLowerCase().includes(normalizedSearch)
        && items.findIndex((candidate) => candidate.to === item.to && candidate.title === item.title) === index
      )
    : [];
  
  return (
    <Box
      sx={{
        "& .pro-sidebar": {
          display: "flex",
          flexDirection: "column",
          height: "100vh",
          width: collapsed ? "88px" : "280px",
          minWidth: collapsed ? "88px" : "280px",
          transition: "width 180ms ease",
        },
        "& .pro-sidebar-inner": {
          background: `${sidebarPalette.background} !important`,
          borderRadius: "24px",
          border: `1px solid ${sidebarPalette.border}`,
          overflow: "hidden",
        },
        "& .pro-sidebar .pro-sidebar-header": {
          padding: "18px 18px",
        },
        "& .pro-sidebar .pro-sidebar-content": {
          paddingTop: "12px",
          overflowY: "auto",
        },
        "& .pro-inner-item": {
          padding: "10px 18px 10px 22px !important",
          borderRadius: "14px !important",
        },
        "& .pro-inner-item:hover": {
          background: `${sidebarPalette.hover} !important`,
          color: `${sidebarPalette.text} !important`,
        },
        "& .pro-menu-item.active": {
          backgroundColor: `${sidebarPalette.active} !important`,
          color: `${sidebarPalette.text} !important`,
        },
        "& .pro-icon-wrapper": {
          backgroundColor: "transparent !important",
          color: `${sidebarPalette.icon} !important`,
        },
        "& .pro-sub-menu > .pro-inner-list-item": {
          background: `${sidebarPalette.submenu.panelBg} !important`,
          borderLeft: `1px solid ${sidebarPalette.submenu.panelBorder}`,
          marginLeft: "12px",
          height: "100vh",
          borderRadius: "0 0 16px 16px",
          overflow: "hidden",
        },
        "& .pro-inner-list-item .pro-sub-menu > .pro-inner-list-item": {
          height: "auto",
        },
        "& .pro-sub-menu > .pro-inner-list-item .MuiTypography-root": {
          fontSize: `${sidebarPalette.submenu.itemTextSize} !important`,
        },
        "& .pro-sub-menu .pro-inner-list-item .pro-inner-item:hover": {
          background: `${sidebarPalette.submenu.hoverBg} !important`,
          color: `${sidebarPalette.text} !important`,
        },
        "& .pro-sub-menu .pro-arrow-wrapper .pro-arrow": {
          borderColor: `${sidebarPalette.submenu.arrowColor} !important`,
        },
        "& .pro-sub-menu.open > .pro-inner-item": {
          color: `${sidebarPalette.text} !important`,
        },
      }}
    >
      <ProSidebar collapsed={collapsed}>
        <SidebarHeader>
          <Box display="flex" flexDirection="column" gap={2}>
            <Box display="flex" alignItems="center" justifyContent={collapsed ? "center" : "space-between"}>
              {!collapsed && (
                <Typography variant="h6" color={sidebarPalette.text} fontWeight={700}>
                  Business Journal
                </Typography>
              )}
              <IconButton onClick={() => setCollapsed((prev) => !prev)} sx={{ color: sidebarPalette.text }}>
                <MenuOutlinedIcon />
              </IconButton>
            </Box>

            {!collapsed && (
              <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                p={2}
                sx={{
                  backgroundColor: sidebarPalette.panel,
                  border: `1px solid ${sidebarPalette.border}`,
                  borderRadius: "18px",
                  boxShadow: "0 18px 40px rgba(0,0,0,0.18)",
                }}
              >
                {(() => {
                  const logoSrc = compLogo || `${process.env.PUBLIC_URL}/jaboylogo.png`;
                  return (
                    <Box sx={styles.logoWrapper}
                      component="img"
                      src={logoSrc}
                      alt="Company logo"
                      onError={(e) => {
                        // fallback to public path if compLogo is invalid
                        if (e && e.target) e.target.src = `${process.env.PUBLIC_URL}/jaboylogo.png`;
                      }}
                      //sx={{ width: 88, height: 88, borderRadius: "50%", objectFit: "cover" }}
                    />
                  );
                })()}
                {/* <Typography variant="subtitle1" color={colors.grey[100]} fontWeight={700} sx={{ mt: 1 }}>
                  {company}
                </Typography>
                <Typography variant="body2" color={colors.grey[400]}>
                  {userName}
                </Typography> */}
              </Box>
            )}
          </Box>
        </SidebarHeader>

        <SidebarContent>
          <Box px={collapsed ? 1 : 2} pt={1} pb={0.5}>
            {collapsed ? (
              <Tooltip title="Search modules" placement="right">
                <IconButton onClick={() => setCollapsed(false)} sx={{ color: sidebarPalette.text }}>
                  <SearchOutlinedIcon />
                </IconButton>
              </Tooltip>
            ) : (
              <TextField
                fullWidth
                size="small"
                value={searchQuery}
                onChange={(event) => setSearchQuery(event.target.value)}
                placeholder="Search modules..."
                inputProps={{ "aria-label": "Search modules" }}
                InputProps={{
                  startAdornment: <InputAdornment position="start"><SearchOutlinedIcon fontSize="small" /></InputAdornment>,
                  endAdornment: searchQuery ? (
                    <InputAdornment position="end">
                      <IconButton size="small" aria-label="Clear module search" onClick={() => setSearchQuery("")}><CloseOutlinedIcon fontSize="small" /></IconButton>
                    </InputAdornment>
                  ) : null,
                }}
                sx={{
                  "& .MuiOutlinedInput-root": { bgcolor: sidebarPalette.input, color: sidebarPalette.text, borderRadius: 2 },
                  "& .MuiOutlinedInput-notchedOutline": { borderColor: sidebarPalette.border },
                  "& .MuiSvgIcon-root": { color: sidebarPalette.icon },
                  "& input::placeholder": { color: sidebarPalette.muted, opacity: 1 },
                }}
              />
            )}
          </Box>
          <Menu iconShape="circle">
            {normalizedSearch && searchResults.map((item) => (
              <Tooltip key={`${item.id}-${item.to}`} title={`${item.group} / ${item.title}`} placement="right" disableHoverListener={!collapsed}>
                <Box>
                  <SidebarItem title={item.title} to={item.to} icon={item.icon} selected={selected} collapsed={collapsed} />
                </Box>
              </Tooltip>
            ))}
            {normalizedSearch && !searchResults.length && !collapsed && (
              <Box px={2.5} py={3} textAlign="center">
                <Typography color={sidebarPalette.muted} fontSize="0.85rem">No accessible module found.</Typography>
              </Box>
            )}
            {!normalizedSearch && (<>
            {mainLinks.map((item) => 
            canAccess(item.id) ? (
              <Tooltip key={item.id} title={item.title} placement="right" disableHoverListener={!collapsed}>
                <Box>
                  <SidebarItem
                    title={item.title}
                    to={item.to}
                    icon={item.icon}
                    selected={selected}
                    collapsed={collapsed}
                  />
                </Box>
              </Tooltip>
            ): null
            )}

            {showTransactions && (
              <SidebarSubMenu title={collapsed ? "" : "Transactions"} to="TLCashReceipts" icon={<StorefrontOutlinedIcon />} collapsed={collapsed}>
                {showSales && (
                  <SidebarSubMenu title={collapsed ? "" : "Sales"} to="TLCashReceipts" icon={<SellOutlinedIcon />} collapsed={collapsed}>
                    {salesLinks.map((item) =>
                      canAccess(item.id) ? (
                        <SidebarItem
                          key={item.id}
                          title={item.title}
                          to={item.to}
                          icon={item.icon}
                          selected={selected}
                          collapsed={collapsed}
                        />
                      ) : null
                    )}
                  </SidebarSubMenu>
                )}
                {showPurchases && (
                  <SidebarSubMenu title={collapsed ? "" : "Purchases"} to="team" icon={<ShoppingCartOutlinedIcon />} collapsed={collapsed}>
                    {purchaseLinks.map((item) =>
                      canAccess(item.id) ? (
                        <SidebarItem
                          key={item.id}
                          title={item.title}
                          to={item.to}
                          icon={item.icon}
                          selected={selected}
                          collapsed={collapsed}
                        />
                      ) : null
                    )}
                  </SidebarSubMenu>
                )}
                {showGenAcct && (
                  <SidebarSubMenu title={collapsed ? "" : "Gen. Acctg"} to="team" icon={<LibraryBooksOutlinedIcon />} collapsed={collapsed}>
                    {genAcctLinks.map((item) =>
                      canAccess(item.id) ? (
                        <SidebarItem
                          key={item.id}
                          title={item.title}
                          to={item.to}
                          icon={item.icon}
                          selected={selected}
                          collapsed={collapsed}
                        />
                      ) : null
                    )}
                  </SidebarSubMenu>
                )}
              </SidebarSubMenu>
            )}
            {showReports && (
              <SidebarSubMenu title={collapsed ? "" : "Reports"} to="Report_ARAging" icon={<StorefrontOutlinedIcon />} collapsed={collapsed}>      
                {showARAging && (
                  <SidebarSubMenu title={collapsed ? "" : "AR Reports"} to="Report_ARAging" icon={<SellOutlinedIcon />} collapsed={collapsed}>
                    {ARReportLinks.map((item) =>
                      canAccess(item.id) ? (
                        <SidebarItem
                          key={item.id}
                          title={item.title}
                          to={item.to}
                          icon={item.icon}
                          selected={selected}
                          collapsed={collapsed}
                        />
                      ) : null
                    )}
                     {LiquidationReportLinks.map((item) =>
                      canAccess(item.id) ? (
                        <SidebarItem
                          key={item.id}
                          title={item.title}
                          to={item.to}
                          icon={item.icon}
                          selected={selected}
                          collapsed={collapsed}
                        />
                      ) : null
                    )}
                  </SidebarSubMenu>
                )}
                {showFSReports_Isaca && (
                  <SidebarSubMenu title={collapsed ? "" : "Financial Reports"} to="Report_IS" icon={<StorefrontOutlinedIcon />} collapsed={collapsed}>
                    {ISACAFSReportLinks.map((item)=>
                     canAccess(item.id) ? (
                        <SidebarItem
                          key={item.id}
                          title={item.title}
                          to={item.to}
                          icon={item.icon}
                          selected={selected}
                          collapsed={collapsed}
                        />
                      ) : null

                    )}

                  </SidebarSubMenu>
                )

                }
                {/* {showLiquidationReport && (
                  <SidebarSubMenu title={collapsed ? "" : "Liquidation Report"} to="Report_LiquidationReport" icon={<SellOutlinedIcon />} collapsed={collapsed}>
                    {LiquidationReportLinks.map((item) =>
                      canAccess(item.id) ? (
                        <SidebarItem
                          key={item.id}
                          title={item.title}
                          to={item.to}
                          icon={item.icon}
                          selected={selected}
                          collapsed={collapsed}
                        />
                      ) : null
                    )}
                  </SidebarSubMenu> */}
                {/* )} */}
              </SidebarSubMenu>
            )}

     
            {showAuditModule && (
              <SidebarSubMenu title={collapsed ? "" : "Audit"} to="AUD_CompanyProfile" icon={<StorefrontOutlinedIcon />} collapsed={collapsed}>
                {showAUCompProfile && (
                  <SidebarSubMenu title={collapsed ? "" : "Company Profile"} to="AUD_CompanyProfile" icon={<SellOutlinedIcon />} collapsed={collapsed}>
                    {AuditModuleLinks.map((item) =>
                      canAccess(item.id) ? (
                        <SidebarItem
                          key={item.id}
                          title={item.title}
                          to={item.to}
                          icon={item.icon}
                          selected={selected}
                          collapsed={collapsed}
                        />
                      ) : null
                    )}
                  </SidebarSubMenu>
                )}
              </SidebarSubMenu>
            )}


            {showInventory && (
              <SidebarSubMenu title={collapsed ? "" : "Inventory"} to={canAccess("INVTRYDB") ? "InventoryDashboard" : undefined} icon={<StorefrontOutlinedIcon />} collapsed={collapsed}>
                {canAccess("INVTRYDB") && (
                  <SidebarItem
                    title="Dashboard"
                    to="InventoryDashboard"
                    icon={<MenuBookOutlinedIcon />}
                    selected={selected}
                    collapsed={collapsed}
                  />
                )}

                {showInventoryIn && (
                  <SidebarSubMenu
                    title={collapsed ? "" : <Typography sx={{ color: sidebarPalette.submenu.defaultText, fontSize: sidebarPalette.submenu.textSize, fontWeight: sidebarPalette.submenu.fontWeight }}>Inventory IN</Typography>}
                    icon={<ShoppingCartOutlinedIcon />}
                    collapsed={collapsed}
                  >
                  {InventoryInLinks.map((item) => canAccess(item.id) ? (
                    <SidebarItem
                      key={item.id}
                      title={item.title}
                      to={item.to}
                      icon={item.icon}
                      selected={selected}
                      collapsed={collapsed}
                    />
                  ) : null)}
                  </SidebarSubMenu>
                )}

                {showInventoryOut && (
                  <SidebarSubMenu
                    title={collapsed ? "" : <Typography sx={{ color: sidebarPalette.submenu.defaultText, fontSize: sidebarPalette.submenu.textSize, fontWeight: sidebarPalette.submenu.fontWeight }}>Inventory Out</Typography>}
                    icon={<SellOutlinedIcon />}
                    collapsed={collapsed}
                  >
                  {InventoryOutLinks.map((item) => canAccess(item.id) ? (
                      <SidebarItem
                        key={item.id}
                        title={item.title}
                        to={item.to}
                        icon={item.icon}
                        selected={selected}
                        collapsed={collapsed}
                      />
                  ) : null)}
                  </SidebarSubMenu>
                )}

                {showInventoryReports && (
                  <SidebarSubMenu
                    title={collapsed ? "" : <Typography sx={{ color: sidebarPalette.submenu.defaultText, fontSize: sidebarPalette.submenu.textSize, fontWeight: sidebarPalette.submenu.fontWeight }}>Inventory Reports</Typography>}
                    icon={<InsertDriveFileOutlinedIcon />}
                    collapsed={collapsed}
                  >
                    {InventoryReportLinks.map((item) => canAccess(item.id) ? (
                      <SidebarItem
                        key={item.to}
                        title={item.title}
                        to={item.to}
                        icon={item.icon}
                        selected={selected}
                        collapsed={collapsed}
                      />
                    ) : null)}
                  </SidebarSubMenu>
                )}
              </SidebarSubMenu>
            )}
            </>)}

            {/* <SidebarSubMenu title={collapsed ? "" : "Books of Accounts"} to="team" icon={<LibraryBooksOutlinedIcon />} collapsed={collapsed}>
              <SidebarItem title="Cash Receipts Journal" to="team" icon={<PaidOutlinedIcon />} selected={selected} collapsed={collapsed} />
              <SidebarItem title="Cash Disbursement Journal" to="contacts" icon={<PaymentsOutlinedIcon />} selected={selected} collapsed={collapsed} />
              <SidebarItem title="Sales Journal" to="invoices" icon={<SellOutlinedIcon />} selected={selected} collapsed={collapsed} />
              <SidebarItem title="Purchase Journal" to="invoices" icon={<ShoppingCartOutlinedIcon />} selected={selected} collapsed={collapsed} />
            </SidebarSubMenu>

            <SidebarSubMenu title={collapsed ? "" : "BIR Forms"} to="team" icon={<AssignmentOutlinedIcon />} collapsed={collapsed}>
              <SidebarItem title="VAT Returns" to="team" icon={<InsertDriveFileOutlinedIcon />} selected={selected} collapsed={collapsed} />
              <SidebarItem title="WTax Expanded Returns" to="team" icon={<BalanceOutlinedIcon />} selected={selected} collapsed={collapsed} />
            </SidebarSubMenu>

            <SidebarSubMenu title={collapsed ? "" : "Financial Reports"} to="invoices" icon={<AssessmentOutlinedIcon />} collapsed={collapsed}>
              <SidebarItem title="Worksheet" to="invoices" icon={<DescriptionOutlinedIcon />} selected={selected} collapsed={collapsed} />
              <SidebarItem title="Trial Balance" to="invoices" icon={<BalanceOutlinedIcon />} selected={selected} collapsed={collapsed} />
              <SidebarItem title="Income Statement" to="invoices" icon={<TrendingUpOutlinedIcon />} selected={selected} collapsed={collapsed} />
            </SidebarSubMenu> */}
          </Menu>
        </SidebarContent>

        <SidebarFooter>
          <Box p={2} display="flex" justifyContent={collapsed ? "center" : "space-between"} alignItems="center">
            <Typography color={sidebarPalette.muted} fontSize="0.8rem">
              © 2025 Business Journal
            </Typography>
          </Box>
        </SidebarFooter>
      </ProSidebar>
    </Box>
  );
};



const styles = {
  sidebarSubMenuLight: {
    defaultText: '#174b72',
    activeText: '#082f4d',
    activeBg: 'linear-gradient(135deg, rgba(11,103,178,0.20), rgba(66,165,245,0.16))',
    hoverBg: 'rgba(11,103,178,0.12)',
    panelBg: '#dceeff',
    border: '#78add8',
    panelBorder: '#9bc7ee',
    arrowColor: '#0b67b2',
    textSize: '0.80rem',
    itemTextSize: '0.80rem',
    fontWeight: 600,
  },
  sidebarSubMenuDark: {
    defaultText: '#d7ebfb',
    activeText: '#ffffff',
    activeBg: 'linear-gradient(135deg, rgba(25,118,210,0.40), rgba(66,165,245,0.22))',
    hoverBg: 'rgba(66,165,245,0.16)',
    panelBg: '#102f49',
    border: '#42a5f5',
    panelBorder: '#315b7d',
    arrowColor: '#90caf9',
    textSize: '0.80rem',
    itemTextSize: '0.80rem',
    fontWeight: 600,
  },
  logoWrapper: {
    display: 'block',
    width: '100%',
    maxWidth: '160px',
    height: '50px',
    margin: '0 auto',
    objectFit: 'contain',
    objectPosition: 'center',
    borderRadius: '10%',
   
 
    //backgroundColor: '#f9fbff', // Optional: Add a background color if needed
    //boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Optional: Add a subtle shadow for better visibility

     //sx={{ width: 88, height: 88, borderRadius: "50%", objectFit: "cover" }}
  },
};

export default Sidebar;
